import React from 'react';
import {
    PAYROLL_STATUS_BONUS_PROVIDED,
    PAYROLL_STATUS_EOR_PARTNER_PAID, PAYROLL_STATUS_PAID,
    PAYROLL_STATUS_PENDING_BONUS,
    PAYROLL_STATUS_PENDING_COMPANY_PAYMENT,
    PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT,
    PAYROLL_STATUS_PENDING_PAYSLIP,
    PAYROLL_STATUS_PREPARING
} from "../../../../utils/constants";
import PayrollBonusProvided from "../PayrollBonusProvided";
import {CompletePayroll} from "../../../../app/interfaces";
import PayrollPreparing from "../PayrollPreparing";
import PayrollDetailsView from "../PayrollDetailsView";
import PayrollPartnerPayment from "../PayrollPartnerPayment";
import PayrollNotifyCustomer from "../PayrollNotifyCustomer";
import PayrollPendingPayslip from "../PayrollPendingPayslip";
export const PayrollActions = ({payroll}: { payroll: CompletePayroll }) => {
    const {status} = payroll;
    switch (status){
        case PAYROLL_STATUS_PENDING_BONUS:
             return null;
        case PAYROLL_STATUS_BONUS_PROVIDED:
            return <PayrollBonusProvided payroll={payroll}/>
        case PAYROLL_STATUS_PREPARING :
            return <PayrollPreparing payroll={payroll}/>
        case PAYROLL_STATUS_PENDING_COMPANY_PAYMENT :
            return <PayrollDetailsView payroll={payroll}/>
        case PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT:
            return <PayrollPartnerPayment payroll={payroll}/>
        case PAYROLL_STATUS_EOR_PARTNER_PAID:
            return <PayrollNotifyCustomer payroll={payroll}/>
        case PAYROLL_STATUS_PENDING_PAYSLIP:
            return <PayrollPendingPayslip payroll={payroll}/>
        case PAYROLL_STATUS_PAID:
            return <PayrollDetailsView payroll={payroll}/>
    }

    return null;
}

export default PayrollActions;
